import React from 'react';
import styled from '../../styled';
import { Chevron } from '../icons/outline';
const Link = styled.a `
  text-decoration: none;
  line-height: 1.43;
  color: ${props => props.theme.colors.INK_500};

  &:hover {
    cursor: pointer;
    color: ${props => props.theme.colors.PRIMARY_600};
  }

  &:focus {
    color: ${props => props.theme.colors.PRIMARY_700};
  }
`;
const Label = styled.span `
  color: ${props => props.isActive ? props.theme.colors.INK_800 : props.theme.colors.INK_500};
  font-weight: ${props => (props.isActive ? 600 : 'normal')};
  line-height: 1.43;
`;
const Wrapper = styled.div `
  display: inline-block;
  vertical-align: middle;
  font-size: 14px;

  > * {
    display: inline-block;
    vertical-align: middle;
  }

  > svg {
    fill: ${props => props.theme.colors.INK_400};
    padding: 0 4px;
  }
`;
const Breadcrumb = ({ items }) => (React.createElement(Wrapper, null, items.map((item, index) => {
    const isActive = index === items.length - 1;
    if (item.url && index > 0) {
        return (React.createElement(React.Fragment, { key: item.id },
            React.createElement(Chevron, { size: "MEDIUM", position: "RIGHT" }),
            React.createElement(Link, { "data-e2e-id": item.e2eId, href: item.url, onClick: item.onClick, key: item.id }, item.label)));
    }
    if (!item.url && index > 0) {
        return (React.createElement(React.Fragment, { key: item.id },
            React.createElement(Chevron, { size: "MEDIUM", position: "RIGHT" }),
            React.createElement(Label, { "data-e2e-id": item.e2eId, isActive: isActive, onClick: item.onClick }, item.label)));
    }
    if (item.url && index === 0) {
        return (React.createElement(Link, { "data-e2e-id": item.e2eId, href: item.url, key: item.id, onClick: item.onClick }, item.label));
    }
    return (React.createElement(Label, { "data-e2e-id": item.e2eId, key: item.id, isActive: isActive, onClick: item.onClick }, item.label));
})));
export default Breadcrumb;
//# sourceMappingURL=index.js.map